import React from "react";
import { string } from "prop-types";
import cx from "classnames";

const propTypes = {
  /** ARIA role of the menu item. See accessibility section for notes. */
  role: string,
  /** HTML tag of the menu item. Remember, anchors take you elsewhere while buttons do stuff */
  tag: string,
};

const defaultProps = {
  tag: "button",
  role: "menuitem",
};

const CLASS_ROOT = "dropdown__item";

const DropdownItem = ({ className, children, tag, role, ...other }) => {
  const classes = cx(CLASS_ROOT, className);
  const Tag = tag;
  let type = false;

  if (Tag === "button") {
    type = "button";
  }

  return (
    <Tag role={role} className={classes} type={type} {...other}>
      {children}
    </Tag>
  );
};

DropdownItem.displayName = "DropdownItem";
DropdownItem.propTypes = propTypes;
DropdownItem.defaultProps = defaultProps;

export default DropdownItem;
